import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { FuncsService } from 'src/app/shared/funcs.service';
import { GenericResponse } from 'src/app/api-interfaces';
import { IdentityService } from 'src/app/identity/identity.service';
import { LogService } from '../log.service';

@Component({
  selector: 'app-erc-lost-modal-component',
  templateUrl: './erc-lost-modal-component.component.html',
  styleUrls: ['./erc-lost-modal-component.component.sass']
})
export class ErcLostModalComponentComponent implements OnInit {

  isSpinning: boolean = false;
  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  @ViewChild('emergencyCodeModal') public ecModal: TemplateRef<any>;
  @ViewChild('emergencyCodeFooter') public emergencyCodeFooter: TemplateRef<any>;
  private tplModal?: NzModalRef;
  emergencyCodeRecoverForm!: UntypedFormGroup;
  public username: string = '';

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private modalService: NzModalService,
    private authService: AuthService,
    private identityService: IdentityService,
    private logger: LogService
  ) { }

  ngOnInit(): void {
    this.eventsSubscription = this.events.subscribe(() => {
      this.tplModal = this.modalService.create({
        nzTitle: "Recupero codice di emergenza",
        nzContent: this.ecModal,
        nzFooter: this.emergencyCodeFooter,
      });
    });

    this.emergencyCodeRecoverForm = this.fb.group({
      username: [null, [Validators.required]],
      cfOPIva: [null,
        [Validators.required,
        Validators.pattern(RegExp(this.funcs.getValidationPattern("cf_o_piva")))]],
    });
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  onRecoveryEmergencyCodeChange(){
    for (const i in this.emergencyCodeRecoverForm.controls) {
      this.emergencyCodeRecoverForm.controls[i].markAsDirty();
      this.emergencyCodeRecoverForm.controls[i].updateValueAndValidity();
    }

    this.isSpinning = true;

    this.authService.recoverEmergencyCode(this.emergencyCodeRecoverForm.value["username"], this.emergencyCodeRecoverForm.value["cfOPIva"])
      .subscribe(
        (response: GenericResponse) => {
          if(response["esito"] == "OK") {
            this.logger.log("Response OK");
            this.tplModal.close();
          }
        },
        (err: Observable<never>) => {this.isSpinning = false;},
        () => {this.isSpinning = false;},
      );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }
}
